import { render, staticRenderFns } from "./AddSingleRecipeToFolderModal.vue?vue&type=template&id=044dfd3e&"
import script from "./AddSingleRecipeToFolderModal.vue?vue&type=script&lang=js&"
export * from "./AddSingleRecipeToFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSingleRecipeToFolderModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports